import React from "react";
import { BoxPresentacion } from "../../components/boxes/BoxPresentacion";
import bronce from "./bronce.png";
import oro from "./oro.png";
import plata from "./plata.png";

export const DashVendedorMes = ({
  titulo,
  vendedor1,
  vendedor2,
  vendedor3,
}) => {
  return (
    <BoxPresentacion titulo={titulo}>
      <div className="dash-vendedormes">
        <div className="dash-vendedormes-2">
          <div className="space-between">
            <div className="dash-imagen">
              <img src={`data:image/jpeg;base64,${vendedor2.foto}`} />
            </div>
            <div>
              <img className="medalla-plata" src={plata} />
            </div>
            <div className="dash-vendedor-nombre">
              {vendedor2.nombrecompleto}
            </div>
            <div className="dash-vendedor-sucursal">{vendedor2.sucursal}</div>
          </div>
        </div>
        <div className="dash-vendedormes-1">
          <div className="dash-imagen">
            <img src={`data:image/jpeg;base64,${vendedor1.foto}`} />
          </div>
          <div>
            <img className="medalla-oro" src={oro} />
          </div>

          <div className="dash-vendedor-nombre">
            {vendedor1.nombrecompleto}{" "}
          </div>
          <div className="dash-vendedor-sucursal">{vendedor1.sucursal}</div>
        </div>
        <div className="dash-vendedormes-3">
          <div className="space-between">
            <div className="dash-imagen">
              <img src={`data:image/jpeg;base64,${vendedor3.foto}`} />
            </div>
            <div>
              <img className="medalla-bronce" src={bronce} />
            </div>
            <div className="dash-vendedor-nombre">
              {vendedor3.nombrecompleto}
            </div>
            <div className="dash-vendedor-sucursal">{vendedor3.sucursal}</div>
          </div>
          {/* <div className="dash-posicion">
            <div className="podium-bronce">
              {" "}
              <br />3{" "}
            </div>
          </div> */}
        </div>
      </div>
    </BoxPresentacion>
  );
};
